import qs from 'qs'

import config from '@app/config'
import { communicationsApi } from '@app/services'
import type { AxiosRequestConfigWithMeta } from '@app/services/api/types'

import { FetchConversationResponse } from './types'
import { Conversation } from '../../models'

export const fetchConversation = async (
  id: number | string
): Promise<Conversation> => {
  const lang = config.regionalSettings?.language
  const doNotTranslateFromLanguages =
    config.regionalSettings?.languageExceptions || []
  const { data } = await communicationsApi.get<FetchConversationResponse>(
    `conversation/${id}`,
    ({
      _skipReinitOn403: true,
      params: {
        mode: 'chat',
        lang,
        doNotTranslateFrom: doNotTranslateFromLanguages,
      },
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: 'repeat' }),
    } as AxiosRequestConfigWithMeta)
  )

  return data.conversation
}
